import { apiClient, ApiResult } from "@/lib/api-client"
import { AuthUser } from "@/modules/auth/entities/AuthUser"

export interface InviteInfoResponse {
  isExistingUser: boolean
  organizationName: string
  firstName: string
}

export async function getInviteInfo(
  token: string,
  email: string,
): Promise<InviteInfoResponse> {
  const res = await apiClient.get<ApiResult<InviteInfoResponse>>(
    "/auth/invite-info",
    { params: { token, email } },
  )

  if (!res.data.isSuccess || !res.data.value) {
    throw new Error(res.data.error ?? "Failed to fetch invite info")
  }

  return res.data.value
}

export interface CompleteInvitePayload {
  email: string
  inviteToken: string
  tempPassword: string
  newPassword: string
  captchaToken?: string
}

export interface CompleteInviteResponse {
  user: AuthUser
  roles: string[]
  permissions: string[]
  expiresAt?: string
}

export async function completeInvite(
  payload: CompleteInvitePayload,
): Promise<CompleteInviteResponse> {
  const res = await apiClient.post<ApiResult<CompleteInviteResponse>>(
    "/auth/complete-invite",
    { ...payload, captchaToken: payload.captchaToken ?? "" },
  )

  if (!res.data.isSuccess || !res.data.value) {
    throw new Error(res.data.error ?? "Failed to complete invite")
  }

  return res.data.value
}
